import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getJugadores, actualizarJugador } from "../services/api";
import { useAuth } from "../context/AuthContext";
import "../styles/registro.css";
import Swal from "sweetalert2";

export default function EditarJugador() {
  const { id } = useParams();
  const { token } = useAuth();
  const navigate = useNavigate();

   const categoriasOptions = {
    Libres: ["Suma8", "4ta", "5ta", "6ta", "7ma", "8va"],
    Damas: ["Suma11", "6ta", "7ma", "8va"],}

  const [form, setForm] = useState({
    nombre: "",
    email: "",
    password: "",
    categoria: "",
    puntos: "",
    dni: "",
    ciudad: "",
    genero: "",
    celular: "",
    puntos_fecha1: "",
    puntos_fecha2: "",
    puntos_fecha3: "",
    puntos_fecha4: "",
    puntos_fecha5: "",
    puntos_fecha6: "",
    puntos_fecha7: ""
  });

  useEffect(() => {
    if (token && id) {
      getJugadores(token).then(res => {
        const jugador = res.data.find(j => String(j.id) === String(id));
        if (jugador) setForm(jugador);
      });
    }
  }, [token, id]);

  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const updatedForm = { ...form };

    // Validar que la contraseña tenga al menos 6 caracteres si se proporciona
    if (updatedForm.password && updatedForm.password.length < 6) {
      Swal.fire({
        title: "Error",
        text: "La contraseña debe tener al menos 6 caracteres",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return; // Detener el envío si la validación falla
    }

    if (!updatedForm.password) {
      delete updatedForm.password; // Eliminar contraseña si está vacía
    }

    await actualizarJugador(id, updatedForm, token);
    Swal.fire({
      title: "¡Éxito!",
      text: "Jugador actualizado correctamente",
      icon: "success",
      confirmButtonText: "Aceptar",
    }).then(() => {
      navigate("/admin/panel");
    });
  } catch (err) {
    Swal.fire({
      title: "Error",
      text: "Hubo un problema al actualizar el jugador",
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }
};

  const calcularTotalPuntos = (nuevoForm) => {
  const total = 
    Number(nuevoForm.puntos_fecha1) +
    Number(nuevoForm.puntos_fecha2) +
    Number(nuevoForm.puntos_fecha3) +
    Number(nuevoForm.puntos_fecha4) +
    Number(nuevoForm.puntos_fecha5) +
    Number(nuevoForm.puntos_fecha6) +
    Number(nuevoForm.puntos_fecha7);
  return total;
};

const handleChange = (e) => {
  const { name, value } = e.target;
  const nuevoForm = { ...form, [name]: value };
  nuevoForm.puntos = calcularTotalPuntos(nuevoForm);
  setForm(nuevoForm);
};

  return (
    <div className="registro-container">
      <form onSubmit={handleSubmit} className="registro-form">
        <h2>Editar Jugador</h2>
      <div className="registro-row">
          <label>Apellido y Nombre</label>
          <input type="text" placeholder="Nombre"  value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} required/>
        </div>
        <div className="registro-row">
          <label>Correo Electrónico</label>
          <input placeholder="Email" value={form.email}  onChange={e => setForm({ ...form, email: e.target.value })} required />
        </div>
        <div className="registro-row">
          <label>Celular</label>
          <input type="tel" placeholder="Celular" value={form.celular} onChange={e => setForm({ ...form, celular: e.target.value })} required />
        </div>
        <div className="registro-row">
          <label>Cambiar Contraseña</label>
          <input type="password" placeholder="Nueva contraseña (dejar vacío para no cambiar)" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
        </div>
        <div className="registro-row">
          <label>DNI</label>
          <input placeholder="DNI" value={form.dni} onChange={e => setForm({ ...form, dni: e.target.value })} required />
        </div>
        <div className="registro-row">
          <label>Ciudad</label>
          <input placeholder="Ciudad" value={form.ciudad} onChange={e => setForm({ ...form, ciudad: e.target.value })} required />
        </div>
        <div className="registro-row">
          <label>Género</label>
          <select 
            value={form.genero}
            onChange={e => setForm({ ...form, genero: e.target.value, categoria: "" })} 
            required
          >
            <option value="">Selecciona género</option>
            <option value="Libres">Libres</option>
            <option value="Damas">Damas</option>
          </select>
        </div>
        <div className="registro-row">
          <label>Categoría</label>
          <select 
            value={form.categoria}
            onChange={e => setForm({ ...form, categoria: e.target.value })} 
            required
            disabled={!form.genero}
          >
            <option value="">Selecciona categoría</option>
            {form.genero && categoriasOptions[form.genero]?.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>
        <div className="registro-row">
  <label>Puntos Fecha 1</label>
  <input
    type="number"
    name="puntos_fecha1"
    value={form.puntos_fecha1}
    onChange={handleChange}
  />
</div>
<div className="registro-row">
  <label>Puntos Fecha 2</label>
  <input
    type="number"
    name="puntos_fecha2"
    value={form.puntos_fecha2}
    onChange={handleChange}
  />
</div>
<div className="registro-row">
  <label>Puntos Fecha 3</label>
  <input
    type="number"
    name="puntos_fecha3"
    value={form.puntos_fecha3}
    onChange={handleChange}
  />
</div>
<div className="registro-row">
  <label>Puntos Fecha 4</label>
  <input
    type="number"
    name="puntos_fecha4"
    value={form.puntos_fecha4}
    onChange={handleChange}
  />
</div>
<div className="registro-row">
  <label>Puntos Fecha 5</label>
  <input
    type="number"
    name="puntos_fecha5"
    value={form.puntos_fecha5}
    onChange={handleChange}
  />
</div>
<div className="registro-row">
  <label>Puntos Fecha 6</label>
  <input
    type="number"
    name="puntos_fecha6"
    value={form.puntos_fecha6}
    onChange={handleChange}
  />
</div>
<div className="registro-row">
  <label>Puntos Fecha 7</label>
  <input
    type="number"
    name="puntos_fecha7"
    value={form.puntos_fecha7}
    onChange={handleChange}
  />
</div>
<div className="registro-row">
  <label>Total Puntos</label>
  <input
    type="number"
    name="puntos"
    value={form.puntos}
    readOnly
  />


  <button
  type="button"
  onClick={() => setForm({ ...form, puntos: calcularTotalPuntos(form) })}
>
  Sumar Puntos 
</button>
</div>
        <button type="submit">Guardar cambios</button>
        <button type="button" onClick={() => navigate("/admin/panel")}>Cancelar</button>
      </form>
    </div>
  );
}

/*        
        
        <div className="registro-row">
          <label>Contraseña</label>
          <input type="password" placeholder="Contraseña" onChange={e => setForm({ ...form, password: e.target.value })} required />
        </div>
        <div className="registro-row">
          <label>Confirmar Contraseña</label>
          <input type="password" placeholder="Confirmar contraseña" onChange={e => setForm({ ...form, confirmPassword: e.target.value })} required />
        </div>
        
        </div>

        */